export default __webpack_public_path__ + "assets/d3feebb8d15ee1f704359971fe9e1fbb.jpeg";